import { c as _c } from "react/compiler-runtime";
import { cva, type VariantProps } from 'class-variance-authority';
import type { ReactNode } from 'react';
function NavigationBottomContainer(t0) {
  const $ = _c(6);
  const {
    className: t1,
    position: t2,
    children
  } = t0;
  const className = t1 === undefined ? "justify-end" : t1;
  const position = t2 === undefined ? "sticky" : t2;
  let t3;
  if ($[0] !== className || $[1] !== position) {
    t3 = VARIANTS({
      className: ["shadow-xs z-1 flex items-center gap-4 rounded-t-4xl bg-brown-50 p-4 text-xs", className],
      position
    });
    $[0] = className;
    $[1] = position;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t3) {
    t4 = <div className={t3}>{children}</div>;
    $[3] = children;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
export default NavigationBottomContainer;
const VARIANTS = cva('', {
  variants: {
    position: {
      sticky: 'sticky bottom-0',
      fixed: 'fixed bottom-0'
    }
  }
});